import { IParceiroContato } from "./parceiro.model";

export interface IConsultaPredictusPessoaEndereco {
  tipoLogradouro?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  cep?: string;
}

export interface IConsultaPredictusPessoaSocio {
  documento?: string;
  nome?: string;
  cargo?: string;
  participacao?: string;
  dataEntrada?: string;
}

export interface IConsultaPredictusPessoaCNAE {
  ordem?: number;
  codigo?: string;
  descricao?: string;
}

export interface IConsultaPredictusPessoaJuridica {
  cnpj?: string;
  razaoSocial?: string;
  nomeFantasia?: string;
  dataAbertura?: string;
  situacaoCadastral?: string;
  dataSituacaoCadastral?: string;
  cnaePrincipal?: string;
  descricaoCnaePrincipal?: string;
  cnaeSecundario?: string;
  descricaoCnaeSecundario?: string;
  naturezaJuridica?: string;
  descricaoNaturezaJuridica?: string;
  capitalSocial?: string;
  enderecos: IConsultaPredictusPessoaEndereco[];
  telefones: any[];
  emails: string[];
  socios: IConsultaPredictusPessoaSocio[];
  cnaes: IConsultaPredictusPessoaCNAE[];
  dataAtualizacao?: string;
  contatos?: IParceiroContato[];
}

export const MOCK_PESSOA_JURIDICA: IConsultaPredictusPessoaJuridica = {
  cnpj: '999999999999999',
  razaoSocial: 'EMPRESA LTDA',
  nomeFantasia: 'EMPRESA',
  dataAbertura: '2016-03-18',
  situacaoCadastral: 'ATIVA',
  dataSituacaoCadastral: '2016-03-18',
  cnaePrincipal: '8291100',
  descricaoCnaePrincipal: 'ATIVIDADES DE COBRANCAS E INFORMACOES CADASTRAIS',
  cnaeSecundario: '8220200',
  descricaoCnaeSecundario: 'ATIVIDADES DE TELEATENDIMENTO',
  naturezaJuridica: '2062',
  descricaoNaturezaJuridica: 'SOCIEDADE EMPRESARIA LIMITADA',
  capitalSocial: '20000.00',
  contatos: [],
  enderecos: [
    {
      tipoLogradouro: 'AV',
      logradouro: 'LOGRADOURO',
      numero: '123',
      complemento: '2 SL 1203',
      bairro: 'CENTRO',
      cidade: 'SAO PAULO',
      uf: 'SP',
      cep: '88015200'
    }
  ],
  telefones: ['11999999999'],
  emails: ['financeiro@empresa.com.br'],
  socios: [
    {
      documento: '99999999999',
      nome: 'NOME DO SOCIO',
      cargo: 'SOCIO-ADMINISTRADOR',
      participacao: '0.00',
      dataEntrada: '2016-03-18'
    }
  ],
  cnaes: [
    {
      ordem: 0,
      codigo: '8291100',
      descricao: 'ATIVIDADES DE COBRANCAS E INFORMACOES CADASTRAIS'
    },
    {
      ordem: 1,
      codigo: '8220200',
      descricao: 'ATIVIDADES DE TELEATENDIMENTO'
    },
    {
      ordem: 2,
      codigo: '6201501',
      descricao: 'DESENVOLVIMENTO DE PROGRAMAS DE COMPUTADOR SOB ENCOMENDA'
    },
    {
      ordem: 3,
      codigo: '6202300',
      descricao:
        'DESENVOLVIMENTO E LICENCIAMENTO DE PROGRAMAS DE COMPUTADOR CUSTOMIZAVEIS'
    },
    {
      ordem: 4,
      codigo: '5819100',
      descricao: 'EDICAO DE CADASTROS, LISTAS E DE OUTROS PRODUTOS GRAFICOS'
    },
    {
      ordem: 5,
      codigo: '7220700',
      descricao:
        'PESQUISA E DESENVOLVIMENTO EXPERIMENTAL EM CIENCIAS SOCIAIS E HUMANAS'
    },
    {
      ordem: 6,
      codigo: '7320300',
      descricao: 'PESQUISAS DE MERCADO E DE OPINIAO PUBLICA'
    },
    {
      ordem: 7,
      codigo: '6319400',
      descricao:
        'PORTAIS, PROVEDORES DE CONTEUDO E OUTROS SERVICOS DE INFORMACAO NA INTERNET'
    },
    {
      ordem: 8,
      codigo: '6209100',
      descricao:
        'SUPORTE TECNICO, MANUTENCAO E OUTROS SERVICOS EM TECNOLOGIA DA INFORMACAO'
    },
    {
      ordem: 9,
      codigo: '6311900',
      descricao:
        'TRATAMENTO DE DADOS, PROVEDORES DE SERVICOS DE APLICACAO E SERVICOS DE HOSPEDAGEM NA INTERNET'
    },
    {
      ordem: 10,
      codigo: '8599604',
      descricao: 'TREINAMENTO EM DESENVOLVIMENTO PROFISSIONAL E GERENCIAL'
    }
  ],
  dataAtualizacao: '2022-02-18'
};
